import styled from 'styled-components';
import {
  NumberInput as NumberInputComponent,
  TextInput as TextInputComponent,
} from 'src/components/inputs';
import { Checkbox } from '@prisjakt/ui/checkbox/variants';

import { media, layout } from 'src/components/base';
import { PrimaryButton, TextButton } from '@prisjakt/ui/button/variants';
import type { EmailInputProps } from './types';
import { Link } from 'react-router-dom';
import { Dropdown } from '@prisjakt/ui/dropdown';

export const EmailInput = styled.div<EmailInputProps>`
  .pj-ui-text-input {
    margin-right: 1rem;
    &--input {
      height: 45px;
    }
  }
  ${media.smallOnly`
    .pj-ui-text-input {
      margin-right: 0;
    }
  `}
  ${p =>
    p.error &&
    `
    .pj-ui-input--input {
      border-color: ${p.theme.colors.negative700};
    }
  `}
`;

export const RatingWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: ${layout.measurements.spacing100};
  align-items: center;
  margin-top: ${layout.measurements.spacing050};

  p {
    margin: 0;
  }
`;

export const AlertForm = styled.form`
  ${media.smallOnly`
  .pj-ui-input {
  margin-bottom: 1rem;
  }
  `}
`;

export const PriceBelowWrapper = styled.div`
  display: grid;
  gap: ${layout.measurements.spacing050};
`;

export const NumberInput = styled(NumberInputComponent).attrs({
  variant: 'rounded',
})`
  flex: 1 0 auto;
`;

export const TextInput = styled(TextInputComponent).attrs({
  variant: 'rounded',
})<EmailInputProps>`
  flex: 1 0 auto;
`;

export const PriceStepWrapper = styled.div`
  display: flex;
  margin-top: ${layout.measurements.spacing050};
`;

const INPUT_WIDTH = 77;

export const PriceStepInput = styled.div`
  width: ${INPUT_WIDTH}px;
  margin-left: ${layout.measurements.spacing050};
`;

export const ShopsFilterWrapper = styled.div`
  margin-top: ${layout.measurements.spacing025};
  margin-bottom: ${layout.measurements.spacing100};
`;

export const ShopPreferenceWrapper = styled.div`
  margin-top: ${layout.measurements.spacing125};
  margin-bottom: ${layout.measurements.spacing125};
`;

export const ShopSettingsLink = styled(Link)`
  margin-top: ${layout.measurements.spacing025};
  color: ${p => p.theme.text.callToAction};
  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const ShopPreferenceDropdown = styled(Dropdown)`
  margin-top: ${layout.measurements.spacing050};
  margin-bottom: ${layout.measurements.spacing050};
`;

export const CheckboxNotify = styled(Checkbox)`
  margin-top: ${layout.measurements.spacing025};
`;

export const RemoveButton = styled(TextButton)`
  margin-bottom: ${layout.measurements.spacing050};
`;

export const SubmitButtonWrapper = styled.div`
  display: flex;
`;

export const CancelButton = styled(TextButton)`
  width: 100%;
  margin-right: ${layout.measurements.spacing050};
`;

export const SaveAlertButton = styled(PrimaryButton)``;
